import axios from "axios";
import "./baseApi"; // ثبت interceptorها (توکن + مدیریت ۴۰۱)

// وضعیت نشست از روی کوکی HttpOnly (جایگزین اتکا به توکنِ ذخیره‌شده در localStorage).
const session = () => axios.get("account/Session");
const login = (r) => axios.post("account/login", r);
const register = (r) => axios.post("account/register", r);
const confirm = (r) => axios.post("account/confirm", r);
const forgotpassword = (r) => axios.post("account/forgotpassword", r);
const changePassword = (r) => axios.post("account/changepassword", r);
const resendCode = (r) => axios.post("account/resendCode", r);
const userProfile = () => axios.get("account/userprofile");
const updateUserProfile = (r) => axios.put("account/userprofile", r);
const captcha = () => axios.get("Captcha/Create");

export default {
    session,
    login,
    captcha,
    confirm,
    forgotpassword,
    changePassword,
    register,
    userProfile,
    updateUserProfile,
    resendCode,
};
